export default __webpack_public_path__ + "static/GreenhouseGasReductionTargetsandClimateActionPlans-4011a61247dcc71ff376f2bdc47700cb.png";